import { render, staticRenderFns } from "./ChooseTable.vue?vue&type=template&id=6ff6214e&"
import script from "./ChooseTable.vue?vue&type=script&lang=js&"
export * from "./ChooseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports